import axios from 'axios';

export default function userNumber(id, token) {
    const config = {
        headers: { Authorization: token }
    };

    // get user info
    return axios.get(`/api/vps/${id}`, config);
}

